import { gql } from '@apollo/client';

export default gql`
  fragment InspectionFields on Inspection {
    id
    dueDate
    doneAt
    canceledAt
    periodCycle
    periodNumber
    name
    result
    overdue
    incoming
    canceled
    inspectionResultsTotal
  }
`;
